import React, { ReactNode, useEffect } from "react";

import { faAngleDown } from "@fortawesome/pro-solid-svg-icons/faAngleDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import { Button, ButtonProps } from "@mapmycustomers/ui";

import ButtonType from "@app/enum/ButtonType";
import loggingService from "@app/util/logging";

import styles from "./RoundButton.module.scss";

export interface RoundButtonProps extends Omit<ButtonProps, "type"> {
  active?: boolean;
  bordered?: boolean;
  children?: ReactNode;
  className?: string;
  hasMenu?: boolean;
  invisible?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  type?: ButtonType;
}

const RoundButton = ({
  active,
  bordered = true,
  children,
  className,
  hasMenu,
  invisible,
  leftIcon,
  rightIcon,
  type = ButtonType.PRIMARY,
  ...antDButtonProps
}: RoundButtonProps) => {
  useEffect(() => {
    if (rightIcon && hasMenu) {
      loggingService.warning(
        "Both rightIcon and hasMenu props were specified. " +
          "It is recommended to specify just one. Prop 'rightIcon' will always take precedence."
      );
    }
  }, [rightIcon, hasMenu]);
  return (
    <Button
      tabIndex={invisible ? -1 : undefined}
      {...antDButtonProps}
      className={cn(
        styles.container,
        styles[type],
        { [styles.active]: active, [styles.bordered]: bordered },
        className
      )}
      leftIcon={leftIcon}
      rightIcon={!rightIcon && hasMenu ? <FontAwesomeIcon icon={faAngleDown} /> : rightIcon}
      type="pill"
    >
      {children}
    </Button>
  );
};

export default RoundButton;
